const scopes = {
  businesses: "admin-businesses",
  accounts: "admin-accounts",
  locations: "admin-locations",
};

export const LocationsKeys = {
  businesses: {
    all: () => [scopes.businesses] as const,
    byId: (id: string) => [scopes.businesses, id] as const,
  },
  accounts: {
    all: () => [scopes.accounts] as const,
    byId: (id: string) => [scopes.accounts, id] as const,
    logo: (id: string) => [scopes.accounts, id, "logo"] as const,
  },
  locations: {
    all: () => [scopes.locations] as const,
    byId: (id: string) => [scopes.locations, id] as const,
  },
};
